const summer2025 = ["summer 2025", "june 2025", "july 2025", "august 2025"];
const early2026 = ["january 2026", "february 2026", "march 2026"];
//Theme Park Ride Types
const lighteningLaneMultiPass = "LLMP"
const individualLightningLanePass = "ILL"
//Water Park Ride Types
const waterCoaster = "Water Coaster"
const bodySlide = "Body Slide"
const racingTubeSlides = "Racing Tube Slides"
const matSlide = "Mat Slide"
const familyRaftRide = "Family Raft Ride"
const kidsSlide = "Kids' Slides"
const kidsWaterPlayArea = "Kids' Water Play Area"
const lazyRiver = "Lazy River"
const wavePool = "Wave Pool"
const tidalPool = "Tidal Pool"
const scenicWalkthrough = "Scenic Walkthrough"
const scenicRide = "Scenic Ride"

export const rideOptionsByPark = {
  "Magic Kingdom": [
    {
      name: "Astro Orbiter",
      type: lighteningLaneMultiPass,
      height: "Any",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize coasters & big rides",
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "The Barnstormer",
      type: lighteningLaneMultiPass,
      height: "35in (89cm) or taller",
      rideStrategyNotes: [
        "Young Children – Slow rides & character experiences",
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Big Thunder Mountain",
      type: lighteningLaneMultiPass,
      warningNote:
        "Closed Jan 2025 - Reopening with a little bit of magic in 2026",
      closureNoteKeywords: ["January 2025"],
      openingNoteKeywords: ["Spring 2026"],
      height: "40in (102cm) or taller",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize coasters & big rides",
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Buzz Lightyear’s Space Ranger Spin",
      type: lighteningLaneMultiPass,
      warningNote: "Closed August 2025 – Reopening 2026",
      closureNoteKeywords: [...summer2025],
      openingNoteKeywords: ["Spring 2026"],
      height: "Any",
      rideStrategyNotes: [
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Young Children – Slow rides & character experiences",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Dumbo the Flying Elephant",
      type: lighteningLaneMultiPass,
      height: "Any",
      rideStrategyNotes: [
        "Young Children – Slow rides & character experiences",
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Haunted Mansion",
      type: lighteningLaneMultiPass,
      height: "Any",
      rideStrategyNotes: [
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: '"it\'s a small world"',
      type: lighteningLaneMultiPass,
      height: "Any",
      rideStrategyNotes: [
        "Young Children – Slow rides & character experiences",
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Jungle Cruise",
      type: lighteningLaneMultiPass,
      height: "Any",
      rideStrategyNotes: [
        "Go With the Flow – Prioritize shows & dining",
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Liberty Square Riverboat",
      warningNote:
        "Closed permanently on July 7th, 2025 for new Cars Land (Piston Peak)",
      closureNoteKeywords: ["July 7th, 2025"],
      height: "Any",
      rideStrategyNotes: [
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Mad Tea Party",
      type: lighteningLaneMultiPass,
      height: "Any",
      rideStrategyNotes: [
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Young Children – Slow rides & character experiences",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Magic Carpets of Aladdin",
      type: lighteningLaneMultiPass,
      height: "Any",
      rideStrategyNotes: [
        "Young Children – Slow rides & character experiences",
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "The Many Adventures of Winnie‑the‑Pooh",
      type: lighteningLaneMultiPass,
      height: "Any",
      rideStrategyNotes: [
        "Young Children – Slow rides & character experiences",
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Peter Pan’s Flight",
      type: lighteningLaneMultiPass,
      height: "Any",
      rideStrategyNotes: [
        "Young Children – Slow rides & character experiences",
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Pirates of the Caribbean",
      type: lighteningLaneMultiPass,
      height: "Any",
      rideStrategyNotes: [
        "Go With the Flow – Prioritize shows & dining",
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Prince Charming Regal Carrousel",
      height: "Any",
      rideStrategyNotes: [
        "Young Children – Slow rides & character experiences",
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Rivers of America",
      height: "Any",
      warningNote:
        "Closed permanently on July 7th, 2025 for new Cars Land (Piston Peak)",
      closureNoteKeywords: ["July 7th, 2025"],
      openingNoteKeywords: ["TBD"],
      rideStrategyNotes: [
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Seven Dwarfs Mine Train",
      type: individualLightningLanePass,
      height: "38in (97cm) or taller",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize coasters & big rides",
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Space Mountain",
      type: lighteningLaneMultiPass,
      height: "44in (112cm) or taller",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize coasters & big rides",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Swiss Family Treehouse",
      type: lighteningLaneMultiPass,
      height: "Any",
      rideStrategyNotes: [
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Tiana’s Bayou Adventure fka Splash Mountain",
      type: lighteningLaneMultiPass,
      height: "40in (102cm) or taller",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize coasters & big rides",
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Tom Sawyer's Island",
      type: lighteningLaneMultiPass,
      height: "Any",
      warningNote:
        "Closed permanently on July 2025 for new Cars Land (Piston Peak)",
      closureNoteKeywords: [...summer2025],
      openingNoteKeywords: ["TBD"],
      rideStrategyNotes: [
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Young Children – Slow rides & character experiences",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Tommorrowland Speedway",
      type: lighteningLaneMultiPass,
      height: "32in (81cm) or taller",
      rideStrategyNotes: [
        "Young Children – Slow rides & character experiences",
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Tomorrowland Transit Authority PeopleMover",
      height: "Any",
      rideStrategyNotes: [
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "TRON Lightcycle / Run",
      type: individualLightningLanePass,
      height: "48in (122cm) or taller",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize coasters & big rides",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Under the Sea ~ Journey of the Little Mermaid",
      type: lighteningLaneMultiPass,
      height: "Any",
      rideStrategyNotes: [
        "Young Children – Slow rides & character experiences",
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
  ],

  "Hollywood Studios": [
    {
      name: "Alien Swirling Saucers",
      type: lighteningLaneMultiPass,
      height: "32in (83cm) or taller",
      rideStrategyNotes: [
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Young Children – Slow rides & character experiences",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Mickey and Minnie's Runaway Railway",
      type: lighteningLaneMultiPass,
      height: "Any",
      rideStrategyNotes: [
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Millennium Falcon: Smuggler's Run",
      type: lighteningLaneMultiPass,
      height: "38in (97cm) or taller",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize coasters & big rides",
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Rock N' Roller Coaster Starring Aerosmith",
        type: lighteningLaneMultiPass,
      height: "48in (122cm) or taller",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize coasters & big rides",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Slinky Dog Dash",
      type: lighteningLaneMultiPass,
      height: "38in (97 cm) or taller",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize coasters & big rides",
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Star Tours - The Adventures Continue",
      type: lighteningLaneMultiPass,
      height: "40in (102cm) or taller",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize coasters & big rides",
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Star Wars: Rise of the Resistance",
      type: individualLightningLanePass,
      height: "40in (102cm) or taller",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize coasters & big rides",
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "The Twilight Zone Tower of Terror™",
      type: lighteningLaneMultiPass,
      height: "40in (102cm) or taller",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize coasters & big rides",
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Toy Story Mania!",
      type: lighteningLaneMultiPass,
      height: "Any",
      rideStrategyNotes: [
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Young Children – Slow rides & character experiences",
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
  ],
  EPCOT: [
    {
      name: "Frozen Ever After",
      type: lighteningLaneMultiPass,
      height: "Any",
      rideStrategyNotes: [
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Young Children – Slow rides & character experiences",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Gran Fiesta Tour Starring The Three Caballeros",
      height: "Any",
      rideStrategyNotes: [
        "Young Children – Slow rides & character experiences",
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Guardians of the Galaxy: Cosmic Rewind",
      type: individualLightningLanePass,
      height: "42in (107cm) or taller",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize coasters & big rides",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Journey Into Imagination with Figment",
      height: "Any",
      rideStrategyNotes: [
        "Young Children – Slow rides & character experiences",
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Living with the Land",
      height: "Any",
      rideStrategyNotes: [
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Mission: SPACE – Green",
      type: lighteningLaneMultiPass,
      height: "40in (102cm) or taller",
      rideInfoNote:
        "Green = No spinning. Calmer ride ideal for motion-sensitive guests.",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize coasters & big rides",
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Mission: SPACE – Orange",
      type: lighteningLaneMultiPass,
      height: "44in (112cm) or taller",
      rideInfoNote:
        "Orange = Spinning ride with intense G-forces. Not for the faint of heart.",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize coasters & big rides",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Remy’s Ratatouille Adventure",
      type: lighteningLaneMultiPass,
      height: "Any",
      rideStrategyNotes: [
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Young Children – Slow rides & character experiences",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Soarin' Around the World",
      type: lighteningLaneMultiPass,
      height: "40in (102cm) or taller",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize coasters & big rides",
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Spaceship Earth",
      type: lighteningLaneMultiPass,
      height: "Any",
      warningNote:
        "Closing temporarily on August 25, 2025 for routine refurbishment",
      closureNoteKeywords: ["August 25, 2025"],
      rideStrategyNotes: [
        "Go With the Flow – Prioritize shows & dining",
        "Young Children – Slow rides & character experiences",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Test Track",
      type: lighteningLaneMultiPass,
      warningNote: "Closed June 2024 – Reopening 2025",
      closureNoteKeywords: ["June 2024"],
      openingNoteKeywords: ["July 22, 2025"],
      height: "40in (102cm) or taller",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize coasters & big rides",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "The Seas with Nemo & Friends",
      height: "Any",
      rideStrategyNotes: [
        "Young Children – Slow rides & character experiences",
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
  ],
  "Animal Kingdom": [
    {
      name: "Avatar Flight of Passage",
      type: individualLightningLanePass,
      height: "44in (112cm) or taller",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize coasters & big rides",
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "DINOSAUR",
      type: lighteningLaneMultiPass,
      height: "40in (102cm) or taller",
      warningNote: "Closing Early 2026",
      closureNoteKeywords: [...early2026],
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize coasters & big rides",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Expedition Everest",
      type: lighteningLaneMultiPass,
      height: "44in (112cm) or taller",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize coasters & big rides",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Kali River Rapids",
      type: lighteningLaneMultiPass,
      height: "38in (97cm) or taller",
      rideStrategyNotes: [
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Kilimanjaro Safaris",
      type: lighteningLaneMultiPass,
      height: "Any",
      rideStrategyNotes: [
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Young Children – Slow rides & character experiences",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Maharajah Jungle Trek",
      height: "Any",
      warningNote: "Closing Early 2026",
      rideInfoNote:
        "This isn’t a ride — it’s a serene, self-paced walking trail where you can explore lush landscapes and observe tigers, bats, and exotic birds. Perfect for a relaxing break.",
      rideStrategyNotes: [
        "Go With the Flow – Prioritize shows & dining",
        "Young Children – Slow rides & character experiences",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Na’vi River Journey",
      type: lighteningLaneMultiPass,
      height: "Any",
      rideStrategyNotes: [
        "Family-Friendly – Mix of thrill rides & kid-friendly attractions",
        "Young Children – Slow rides & character experiences",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Wildlife Express Train",
      height: "Any",
      rideStrategyNotes: [
        "Go With the Flow – Prioritize shows & dining",
        "Young Children – Slow rides & character experiences",
        "Park Completionist – Ride everything possible",
      ],
    },
  ],

  "Typhoon Lagoon": [
    {
      name: "Crush 'n' Gusher",
      type: waterCoaster,
      zone: "Typhoon Lagoon",
      height: "48 inches",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize high-intensity attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Humunga Kowabunga",
      type: bodySlide,
      zone: "Typhoon Lagoon",
      height: "48 inches",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize high-intensity attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Storm Slides",
      type: bodySlide,
      zone: "Typhoon Lagoon",
      height: "Any",
      rideStrategyNotes: [
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Gang Plank Falls",
      type: familyRaftRide,
      zone: "Typhoon Lagoon",
      height: "Any",
      rideStrategyNotes: [
        "Family Fun – Prioritize kid-friendly attractions",
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Keelhaul Falls",
      type: familyRaftRide,
      zone: "Typhoon Lagoon",
      height: "Any",
      rideStrategyNotes: [
        "Family Fun – Prioritize kid-friendly attractions",
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Mayday Falls",
      type: familyRaftRide,
      zone: "Typhoon Lagoon",
      height: "Any",
      rideStrategyNotes: [
        "Family Fun – Prioritize kid-friendly attractions",
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Miss Adventure Falls",
      type: familyRaftRide,
      zone: "Typhoon Lagoon",
      height: "Any",
      rideStrategyNotes: [
        "Family Fun – Prioritize kid-friendly attractions",
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Bay Slides",
      type: kidsSlide,
      zone: "Typhoon Lagoon",
      height: "Any",
      rideStrategyNotes: ["Family Fun – Prioritize kid-friendly attractions"],
    },
    {
      name: "Ketchakiddee Creek",
      type: kidsWaterPlayArea,
      zone: "Typhoon Lagoon",
      height: "Any",
      rideStrategyNotes: ["Family Fun – Prioritize kid-friendly attractions"],
    },
    {
      name: "Castaway Creek",
      type: lazyRiver,
      zone: "Typhoon Lagoon",
      height: "Any",
      rideStrategyNotes: [
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Typhoon Lagoon Surf Pool",
      type: wavePool,
      zone: "Typhoon Lagoon",
      height: "Any",
      rideStrategyNotes: [
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Whitecap Cove",
      type: tidalPool,
      zone: "Typhoon Lagoon",
      height: "Any",
      rideStrategyNotes: ["Go With the Flow – Prioritize shows & dining"],
    },
    {
      name: "Blustery Bay",
      type: tidalPool,
      zone: "Typhoon Lagoon",
      height: "Any",
      rideStrategyNotes: ["Go With the Flow – Prioritize shows & dining"],
    },
    {
      name: "Forgotten Grotto",
      type: scenicWalkthrough,
      zone: "Typhoon Lagoon",
      height: "Any",
      rideStrategyNotes: ["Go With the Flow – Prioritize shows & dining"],
    },
    {
      name: "Overlook Pass",
      type: scenicWalkthrough,
      zone: "Typhoon Lagoon",
      height: "Any",
      rideStrategyNotes: ["Go With the Flow – Prioritize shows & dining"],
    },
  ],

  "Blizzard Beach": [
    {
      name: "Summit Plummet",
      type: bodySlide,
      zone: "Blizzard Beach",
      height: "48 inches",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize high-intensity attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Slush Gusher",
      type: bodySlide,
      zone: "Blizzard Beach",
      height: "48 inches",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize high-intensity attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Downhill Double Dipper",
      type: racingTubeSlides,
      zone: "Blizzard Beach",
      height: "48 inches",
      rideStrategyNotes: [
        "Thrill Seeker – Prioritize high-intensity attractions",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Toboggan Racers",
      type: matSlide,
      zone: "Blizzard Beach",
      height: "Any",
      rideStrategyNotes: [
        "Family Fun – Prioritize kid-friendly attractions",
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Snow Stormers",
      type: matSlide,
      zone: "Blizzard Beach",
      height: "Any",
      rideStrategyNotes: [
        "Family Fun – Prioritize kid-friendly attractions",
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Runoff Rapids",
      type: familyRaftRide,
      zone: "Blizzard Beach",
      height: "Any",
      rideStrategyNotes: [
        "Family Fun – Prioritize kid-friendly attractions",
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Teamboat Springs",
      type: familyRaftRide,
      zone: "Blizzard Beach",
      height: "Any",
      rideStrategyNotes: [
        "Family Fun – Prioritize kid-friendly attractions",
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Chairlift",
      type: scenicRide,
      zone: "Blizzard Beach",
      height: "Any",
      rideStrategyNotes: ["Go With the Flow – Prioritize shows & dining"],
    },
    {
      name: "Cross Country Creek",
      type: lazyRiver,
      zone: "Blizzard Beach",
      height: "Any",
      rideStrategyNotes: [
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Melt-Away Bay",
      type: wavePool,
      zone: "Blizzard Beach",
      height: "Any",
      rideStrategyNotes: [
        "Go With the Flow – Prioritize shows & dining",
        "Park Completionist – Ride everything possible",
      ],
    },
    {
      name: "Tike's Peak",
      type: kidsWaterPlayArea,
      zone: "Blizzard Beach",
      height: "Any",
      rideStrategyNotes: ["Family Fun – Prioritize kid-friendly attractions"],
    },
    {
      name: "Ski Patrol Training Camp",
      type: kidsWaterPlayArea,
      zone: "Blizzard Beach",
      height: "Any",
      rideStrategyNotes: ["Family Fun – Prioritize kid-friendly attractions"],
    },
  ],
};